/** Analytics identifiers for WOODWORKING PROJECTS THAT SELL™. Empty = off. */
export const META_PIXEL_ID = '1450666107252456'
export const CLARITY_PROJECT_ID = ''
export const FACEBOOK_DOMAIN_VERIFICATION = ''
